import type { RequestParameters, GraphQLSingularResponse } from 'relay-runtime';

import {
	applyQueryOverridesToResponse,
	loadOverridesFromStorage,
} from '@confluence/graphql/entry-points/queryOverridesUtils';

let cachedOverrides: Record<string, any> | null = null;

// Loads query overrides once and caches them.
const getOverrides = (): Record<string, any> => {
	if (cachedOverrides == null) {
		cachedOverrides = loadOverridesFromStorage();
	}
	return cachedOverrides;
};

// Resets the cached overrides. Only used for testing.
export const __TEST_ONLY_resetOverridesCache = (): void => {
	cachedOverrides = null;
};

/**
 * Applies query overrides to a Relay GraphQL response.
 * This is the Relay counterpart to QueryOverridesLink for Apollo.
 *
 * @param response - The GraphQL response to modify
 * @param request - The request parameters containing the operation info
 * @returns The modified response with the same type as input
 */
export const applyRelayQueryOverrides = (
	response: GraphQLSingularResponse,
	request: RequestParameters,
): GraphQLSingularResponse => {
	if (response?.data == null) {
		return response;
	}

	const overrides = getOverrides();

	// no overrides are present in localStorage
	if (Object.keys(overrides).length === 0) {
		return response;
	}

	return applyQueryOverridesToResponse<GraphQLSingularResponse>({
		overrides,
		response,
		relayRequest: request,
	});
};

export const shouldEnableQueryOverrides = (): boolean => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		return false;
	}

	return (
		process.env.CLOUD_ENV === 'hello' ||
		process.env.CLOUD_ENV === 'staging' ||
		process.env.CLOUD_ENV === 'branch' ||
		(process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'testing')
	);
};
